// extracted by mini-css-extract-plugin
module.exports = {"discountedPrice":"styles__discountedPrice--1YTYQ"};